/*
  hoshiami キャンペーン（進捗バー・プレゼント受け取り・おすすめ追加）
  ------------------------------------------------------------------
  - すべてイベント委任（document）で動くので、ドロワーやカートページが再描画されても効き続ける
  - カート操作のあとは Section Rendering API でドロワー／カートページ／商品ページのバーを描き直す
  - クーポンは /cart/update.js の discount で適用。効かない環境では /discount/CODE にフォールバック
  - 点数が複数のプレゼントは、カラー選択を点数ぶん集めて同じカラーはまとめて追加（別色OK）
  - バーの点・リボンはタップで吹き出し（金額と内容）
*/
(function () {
  'use strict';
  if (window.__hoshiamiCampaignLoaded) return;
  window.__hoshiamiCampaignLoaded = true;

  var busy = false;
  var routes = window.routes || {};
  var cartUrl = routes.cart_url || '/cart';

  function jsonHeaders() {
    return { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  }

  function showError(root, msg) {
    var el = root && root.querySelector('[data-hc-error]');
    if (!el) { alert(msg); return; }
    el.textContent = msg;
    el.hidden = false;
  }

  function setLoading(btn, on) {
    if (!btn) return;
    btn.disabled = !!on;
    btn.classList.toggle('is-loading', !!on);
  }

  /* ---------- カート操作 ---------- */
  function addItems(items) {
    return fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
  }

  function changeLine(key, qty) {
    return fetch(routes.cart_change_url || '/cart/change.js', {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function removeLines(keys) {
    var list = String(keys || '').split(',').filter(Boolean);
    var p = Promise.resolve();
    list.forEach(function (k) { p = p.then(function () { return changeLine(k, 0); }); });
    return p;
  }

  function applyCode(code) {
    if (!code) return Promise.resolve(false);
    // 既に効いているコードは残す（プレゼント同士は併用できる設定にしてある）。update.js の discount はカンマ区切りで複数指定できる
    return fetch(cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var codes = [];
        if (cart && Array.isArray(cart.discount_codes)) {
          cart.discount_codes.forEach(function (d) {
            if (d && d.applicable && d.code && String(d.code).toLowerCase() !== String(code).toLowerCase()) codes.push(d.code);
          });
        }
        codes.push(code);
        return fetch(routes.cart_update_url || '/cart/update.js', {
          method: 'POST',
          headers: jsonHeaders(),
          body: JSON.stringify({ discount: codes.join(',') })
        });
      })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var applied = false;
        if (cart && Array.isArray(cart.discount_codes)) {
          applied = cart.discount_codes.some(function (d) {
            return d && String(d.code).toLowerCase() === String(code).toLowerCase();
          });
        }
        if (applied) return true;
        // フォールバック：従来の /discount/CODE（Cookie で適用）
        return fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl), {
          credentials: 'same-origin',
          redirect: 'follow'
        }).then(function () { return true; }).catch(function () { return false; });
      })
      .catch(function () { return false; });
  }

  /* ---------- 再描画 ---------- */
  function refreshDrawer(openIt) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var wrap = document.getElementById('CartDrawer');
        if (wrap && sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var src = doc.querySelector('#CartDrawer');
          if (src) wrap.innerHTML = src.innerHTML;
          var inner = drawer.querySelector('.drawer__inner');
          var hasItems = !!drawer.querySelector('.cart-item');
          drawer.classList.toggle('is-empty', !hasItems);
          if (inner) inner.classList.toggle('is-empty', !hasItems);
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var d2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var s2 = d2.querySelector('.shopify-section');
          if (s2) bubble.innerHTML = s2.innerHTML;
        }
        if (openIt && typeof drawer.open === 'function') {
          var ov = drawer.querySelector('#CartDrawer-Overlay');
          if (ov) ov.addEventListener('click', drawer.close.bind(drawer));
          drawer.open();
        }
      })
      .catch(function (e) { console.error('[hoshiami-campaign] drawer refresh failed', e); });
  }

  function refreshCartPage() {
    var itemsEl = document.getElementById('main-cart-items');
    var footEl = document.getElementById('main-cart-footer');
    if (!itemsEl) return Promise.resolve();
    var ids = [itemsEl.dataset.id];
    if (footEl && footEl.dataset.id) ids.push(footEl.dataset.id);
    return fetch(cartUrl + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        [[itemsEl, ids[0]], [footEl, ids[1]]].forEach(function (pair) {
          var el = pair[0], id = pair[1];
          if (!el || !id || !sections[id]) return;
          var doc = new DOMParser().parseFromString(sections[id], 'text/html');
          var src = doc.querySelector('.js-contents');
          var dst = el.querySelector('.js-contents');
          if (src && dst) dst.innerHTML = src.innerHTML;
        });
        var hasItems = !!itemsEl.querySelector('.cart-item');
        var cartItems = itemsEl.closest('cart-items');
        if (cartItems) cartItems.classList.toggle('is-empty', !hasItems);
        if (footEl) footEl.classList.toggle('is-empty', !hasItems);
      })
      .catch(function (e) { console.error('[hoshiami-campaign] cart page refresh failed', e); });
  }

  function refreshProductBar() {
    var root = document.querySelector('[data-hc-root="product"]');
    if (!root) return Promise.resolve();
    var host = root.parentElement;
    return fetch(window.location.pathname + '?section_id=hoshiami-campaign-bar', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-hc-root="product"]');
        if (fresh && host) host.replaceChild(fresh, root);
        else if (host && !fresh) root.remove();
      })
      .catch(function (e) { console.error('[hoshiami-campaign] product bar refresh failed', e); });
  }

  function onCartPage() { return !!document.getElementById('main-cart-items'); }

  function refreshAll(openDrawer) {
    return Promise.all([refreshDrawer(openDrawer && !onCartPage()), refreshCartPage(), refreshProductBar()]);
  }

  // 他の場所（商品フォームなど）でカートが変わったら、商品ページのバーも追随
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (evt && evt.source === 'hoshiami-campaign') return;
      return refreshProductBar();
    });
  }

  function announce() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hoshiami-campaign' }); } catch (e) {}
    }
  }

  /* ---------- Dawn の数量チェックに拾われないようにする ----------
     cart-items / cart-drawer-items は内側の change イベントをすべて「数量変更」として検証する。
     こちらのカラー選択 <select> はキャプチャ段階で止める（値の変更自体は有効）。 */
  /* ---------- バリエーション選択 ----------
     [data-hc-picker] ごとに「今選ばれている variant」を解決する。
     単一オプション: <select data-hc-variant-select> の value。
     複数オプション（サイズ×カラー等）: 各 <select data-hc-opt> の組み合わせを data-hc-variants から探す。 */
  function money(cents) {
    var f = (window.hoshiamiMoneyFormat || '¥{{amount_no_decimals}}');
    var yen = Math.round(Number(cents) / 100);
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, yen.toLocaleString('ja-JP')).replace(/\{\{[^}]*\}\}/, yen.toLocaleString('ja-JP'));
  }
  function pickerVariants(picker) {
    try { return JSON.parse(picker.getAttribute('data-hc-variants') || '[]'); } catch (e) { return []; }
  }
  function pickerSelects(picker) { return Array.prototype.slice.call(picker.querySelectorAll('[data-hc-opt]')); }
  function findExact(list, vals) {
    return list.filter(function (v) {
      return v.o && v.o.length === vals.length && v.o.every(function (x, i) { return String(x) === vals[i]; });
    })[0];
  }
  /* 合わなくなったら最も近い在庫ありの組み合わせへ（変更したオプションは必ず守り、他は一致数が多いもの） */
  function nearest(list, vals, keep) {
    var best = null, bestScore = -1;
    list.forEach(function (v) {
      if (!v.o || v.o.length !== vals.length) return;
      if (keep != null && String(v.o[keep]) !== vals[keep]) return;
      var score = 0;
      v.o.forEach(function (x, i) { if (String(x) === vals[i]) score += (i === keep ? 100 : 1); });
      if (score > bestScore) { bestScore = score; best = v; }
    });
    return best;
  }
  /* 他の選択と合わない値を（在庫切れ）にして選べなくする（Shopify 商品ページの挙動と同じ） */
  function applyDisables(picker) {
    var sels = pickerSelects(picker);
    if (!sels.length) return;
    var list = pickerVariants(picker);
    var vals = sels.map(function (s) { return s.value; });
    sels.forEach(function (sel, j) {
      Array.prototype.forEach.call(sel.options, function (opt) {
        var ok = list.some(function (v) {
          if (!v.o) return false;
          if (String(v.o[j]) !== opt.value) return false;
          return v.o.every(function (x, k) { return k === j || !vals[k] || String(x) === vals[k]; });
        });
        opt.disabled = !ok;
        var base = opt.getAttribute('data-label') || opt.textContent.replace(/（在庫切れ）$/, '');
        if (!opt.getAttribute('data-label')) { opt.setAttribute('data-label', base); opt.value = opt.value || base; }
        opt.textContent = ok ? base : base + '（在庫切れ）';
      });
    });
  }
  function resolvePicker(picker) {
    var single = picker.querySelector('[data-hc-variant-select]');
    if (single) {
      var o = single.options[single.selectedIndex];
      return single.value ? { id: single.value, img: o && o.getAttribute('data-img'), price: o && o.getAttribute('data-price'), complete: true } : { id: '', complete: false };
    }
    var sels = pickerSelects(picker);
    var vals = sels.map(function (s) { return s.value; });
    if (vals.some(function (v) { return !v; })) return { id: '', complete: false };
    var hit = findExact(pickerVariants(picker), vals);
    return hit ? { id: String(hit.id), img: hit.img, price: hit.p, complete: true } : { id: '', complete: true, unavailable: true };
  }
  function applyPickerVisual(picker, changedIndex) {
    var sels = pickerSelects(picker);
    if (sels.length) {
      var list = pickerVariants(picker);
      var vals = sels.map(function (s) { return s.value; });
      if (!findExact(list, vals)) {
        var near = nearest(list, vals, changedIndex) || nearest(list, vals, null);
        if (near) sels.forEach(function (s, i) { s.value = String(near.o[i]); });
      }
      applyDisables(picker);
    }
    var r = resolvePicker(picker);
    picker.setAttribute('data-hc-variant', r.id || '');
    var holder = picker.closest('.hc__opt') || picker.closest('.hc__rec') || picker.parentElement;
    var img = holder && holder.querySelector('[data-hc-img]');
    if (img) {
      if (!img.getAttribute('data-orig')) img.setAttribute('data-orig', img.getAttribute('src') || '');
      img.setAttribute('src', r.img || img.getAttribute('data-orig'));
      img.removeAttribute('srcset');
    }
    var price = holder && holder.querySelector('[data-hc-price]');
    if (price && r.price != null && r.id) {
      if (!price.getAttribute('data-orig')) price.setAttribute('data-orig', price.textContent);
      price.textContent = money(r.price);
    }
    var addBtn = holder && holder.querySelector('[data-hc-add],[data-hc-claim]');
    if (addBtn && !addBtn.classList.contains('is-loading')) addBtn.disabled = !r.id;
    return r;
  }
  document.addEventListener('change', function (ev) {
    var sel = ev.target;
    if (!sel || !sel.matches || !sel.matches('[data-hc-sel]')) return;
    ev.stopPropagation();
    var picker = sel.closest('[data-hc-picker]');
    if (!picker) return;
    var box = picker.closest('.hc__claim, .hc__rec');
    var errEl = box && box.querySelector('[data-hc-error]');
    if (errEl) errEl.hidden = true;
    var idx = sel.hasAttribute('data-hc-opt') ? Number(sel.getAttribute('data-hc-opt')) : null;
    applyPickerVisual(picker, idx);
  }, true);
  // ドロップダウンを開く前に、合わない値を（在庫切れ）にしておく
  document.addEventListener('focusin', function (ev) {
    var sel = ev.target;
    if (!sel || !sel.matches || !sel.matches('[data-hc-opt]')) return;
    var picker = sel.closest('[data-hc-picker]');
    if (picker && !picker.__hcDisablesDone) { applyDisables(picker); picker.__hcDisablesDone = true; }
  }, true);

  /* ---------- 吹き出し（点・リボンをタップ） ---------- */
  var tipTimer = null;
  function hideTips() {
    document.querySelectorAll('[data-hc-tipbox]').forEach(function (t) { t.hidden = true; t.removeAttribute('data-for'); });
    if (tipTimer) { clearTimeout(tipTimer); tipTimer = null; }
  }
  function showTip(node) {
    var bar = node.closest('.hc__bar');
    var box = bar && bar.querySelector('[data-hc-tipbox]');
    if (!box) return;
    var key = node.getAttribute('style') + node.getAttribute('data-hc-tip');
    if (!box.hidden && box.getAttribute('data-for') === key) { hideTips(); return; }
    hideTips();
    box.textContent = node.getAttribute('data-hc-tip') || '';
    box.style.left = node.style.left || '0';
    // 端に寄りすぎたら内側にずらす
    var pct = parseFloat(node.style.left) || 0;
    box.style.transform = pct > 82 ? 'translateX(-90%)' : pct < 14 ? 'translateX(-10%)' : 'translateX(-50%)';
    box.setAttribute('data-for', key);
    box.hidden = false;
    tipTimer = setTimeout(hideTips, 3200);
  }
  document.addEventListener('click', function (ev) {
    var node = ev.target.closest && ev.target.closest('[data-hc-tip]');
    if (node) { ev.preventDefault(); showTip(node); return; }
    if (!ev.target.closest || !ev.target.closest('[data-hc-tipbox]')) hideTips();
  });

  /* ---------- クリック委任 ---------- */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-hc-claim],[data-hc-add],[data-hc-remove],[data-hc-apply],[data-hc-copy]');
    if (!btn) return;
    ev.preventDefault();
    if (busy) return;

    var box = btn.closest('.hc__claim, .hc__rec, .hc-card') || btn.parentElement;
    var errEl = box && box.querySelector('[data-hc-error]');
    if (errEl) errEl.hidden = true;

    // コードのコピー
    if (btn.hasAttribute('data-hc-copy')) {
      var code = btn.getAttribute('data-hc-copy');
      var done = function () {
        var orig = btn.textContent;
        btn.textContent = 'コピーしました';
        setTimeout(function () { btn.textContent = orig; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else done();
      return;
    }

    // プレゼントを受け取る／おすすめを追加
    if (btn.hasAttribute('data-hc-claim') || btn.hasAttribute('data-hc-add')) {
      var items = [];
      var variant = btn.getAttribute('data-variant');
      var qty = Number(btn.getAttribute('data-qty')) || 1;
      if (variant) {
        items.push({ id: Number(variant), quantity: qty });
      } else {
        var pickers = box ? Array.prototype.slice.call(box.querySelectorAll('[data-hc-picker]')) : [];
        var firstEmpty = null;
        var unavailable = false;
        var counts = {};
        var order = [];
        pickers.forEach(function (pk) {
          var r = resolvePicker(pk);
          if (!r.complete) { if (!firstEmpty) firstEmpty = pk.querySelector('select'); return; }
          if (!r.id) { unavailable = true; return; }
          if (!counts[r.id]) { counts[r.id] = 0; order.push(r.id); }
          counts[r.id] += 1;
        });
        if (!pickers.length || firstEmpty) {
          showError(box, pickers.length > 1 ? 'カラーをすべて選んでください' : 'カラー・サイズを選んでください');
          if (firstEmpty) firstEmpty.focus();
          return;
        }
        if (unavailable) { showError(box, '在庫切れです'); return; }
        order.forEach(function (id) { items.push({ id: Number(id), quantity: counts[id] }); });
      }
      var claimCode = btn.getAttribute('data-code') || '';
      busy = true; setLoading(btn, true);
      addItems(items)
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.body && (res.body.description || res.body.message)) || '追加できませんでした';
            throw new Error(msg);
          }
          return claimCode ? applyCode(claimCode) : true;
        })
        .then(function () { announce(); return refreshAll(true); })
        .catch(function (e) { showError(box, e.message || '追加できませんでした'); })
        .then(function () { busy = false; setLoading(btn, false); });
      return;
    }

    // コードだけ適用（プレゼントは既にカート内）
    if (btn.hasAttribute('data-hc-apply')) {
      busy = true; setLoading(btn, true);
      applyCode(btn.getAttribute('data-hc-apply'))
        .then(function () { announce(); return refreshAll(false); })
        .then(function () { busy = false; setLoading(btn, false); });
      return;
    }

    // 条件未達のプレゼントをカートから外す（複数行あればすべて）
    if (btn.hasAttribute('data-hc-remove')) {
      busy = true; setLoading(btn, true);
      removeLines(btn.getAttribute('data-hc-remove'))
        .then(function () { announce(); return refreshAll(false); })
        .catch(function () { showError(box, '外せませんでした。カートの数量から削除してください'); })
        .then(function () { busy = false; setLoading(btn, false); });
    }
  });
})();
